export const getGenderText = (genderType) => {
  if (genderType === 'MALE') return '남';
  if (genderType === 'FEMALE') return '여';
  return '미확인';
};